import React, { useContext } from 'react';
import integrationAnimationData from '~/lotties/onboarding/integration-2022.json';
import Lottie from 'react-lottie';
import { lottieOptions } from '.';
import { Card } from '@vimily/bonjoro-ui-components-v2/Card';

const csvImageUrl = 'https://cdn.bonjoro.com/assets/icons/csv-grey.png';
import qs from 'query-string';
import TaskCreationContext from '../TaskCreation/Context';

const cardClassName =
  'w-[290px] h-[130px] cursor-pointer items-center justify-center p-2.5 flex flex-col gap-y-2';

export function FooterPanel() {
  const { workspace } = useContext(TaskCreationContext);

  const onUploadCsvClick = () => {
    window.location.href = `/contacts/csv?${qs.stringify({
      campaign: workspace?.uuid,
    })}`;
  };

  const onIntegrationClick = () => {
    window.location.href = '/automation';
  };

  return (
    <div className='w-full v2-bg-neutral-50 p-8 pt-6 flex flex-col gap-y-5 rounded-b-2xl'>
      <span className='text-[21px] v2-text-neutral-900 font-bold'>
        Other ways to populate your tasklist
      </span>
      <div className='flex flex-col gap-y-4 sm:flex-row sm:gap-x-4 items-center justify-between'>
        <Card className={cardClassName} onClick={onUploadCsvClick}>
          <img className='h-8 w-6' src={csvImageUrl} />
          <span className='text-base font-bold'>Upload CSV</span>
          <span className='text-base font-thin'>One off bulk upload</span>
        </Card>

        <Card className={cardClassName} onClick={onIntegrationClick}>
          <span>
            <Lottie
              options={{
                animationData: integrationAnimationData,
                ...lottieOptions,
              }}
              height={32}
              width={96}
            />
          </span>
          <span className='text-base font-bold'>New CRM integration</span>
          <span className='text-base font-thin'>
            Automatically bring people in
          </span>
        </Card>
      </div>
    </div>
  );
}
